import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {ApiResponseSchedule} from "features/model/types/groups/schedule/scheduleSchema";

interface IFetchScheduleDev {
    month: string,
    year: string,
    time_zone: string | null,
    new: number,
    finished: number,
    has_problem: number,
}

export const fetchScheduleDev = createAsyncThunk(
    "lessons/fetchScheduleDev",
    async (args: { scheduleData: IFetchScheduleDev, userId: string | undefined }, thunkAPI) => {
        const { scheduleData, userId } = args;
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<ApiResponseSchedule>(
                `/api/schedule/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: scheduleData,
                }
            );

            return response.data;

        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
